export default async function fetchTemplate({ commit, rootGetters, dispatch }, templateId) {
    try {
        commit('SET_FETCH_TEMPLATE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/extract-templates/${templateId}?customer_id=${customer_id}`;
        const response = await window.axios.get(url);

        if (response.data.success) {
            const template = response.data.data;
            commit('SET_TEMPLATE', template);
        } else {
            dispatch('notifications/setError', 'Failed to fetch extract template', { root: true });
        }
    } catch (error) {
        console.error('Error fetching extract template:', error);
        dispatch('notifications/setError', 'Failed to fetch extract template', { root: true });
    } finally {
        commit('SET_FETCH_TEMPLATE_LOADING', false);
    }
}